type ScrollLockHandlers = {
  lock: () => void
  unlock: () => void
}

let scrollLockHandlers: ScrollLockHandlers | null = null
let activeModalCount = 0

export function setCookieConsentScrollLockHandlers(handlers: ScrollLockHandlers | null): void {
  scrollLockHandlers = handlers
}

export function lockCookieConsentPageScroll(): void {
  activeModalCount += 1

  if (activeModalCount === 1) {
    scrollLockHandlers?.lock()
    document.documentElement.classList.add('nw-cookie-consent-scroll-lock')
  }
}

export function unlockCookieConsentPageScroll(): void {
  activeModalCount = Math.max(0, activeModalCount - 1)

  if (activeModalCount === 0) {
    scrollLockHandlers?.unlock()
    document.documentElement.classList.remove('nw-cookie-consent-scroll-lock')
  }
}
